/**
 * JURO scroll velocity
 * ------------------------------------------------------------------
 * [data-juro-velocity] marquees run their CSS loop faster the faster the page
 * scrolls, then ease back to their resting speed. Direction never changes:
 * the words always travel right to left (Julius, 2026-09-17). After Magic UI
 * "Scroll Based Velocity".
 *
 * The loop itself stays a CSS animation; this only changes its playbackRate
 * through the Web Animations API, so with JavaScript off (or reduced motion,
 * where the CSS animation is removed) the marquee behaves as before.
 */

(() => {
  if (window.juroVelocityLoaded) return;
  window.juroVelocityLoaded = true;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const strips = new Set();
  let lastY = window.scrollY;
  let lastT = performance.now();
  let rate = 1;
  let frame = 0;

  const tick = (now) => {
    frame = 0;
    const dt = Math.max(16, now - lastT);
    const dy = window.scrollY - lastY;
    lastY = window.scrollY;
    lastT = now;

    // px per frame at 60fps, mapped to a gentle multiplier
    const speed = Math.min(6, Math.abs(dy / dt) * 16 * 0.12);
    const target = 1 + speed;
    rate += (target - rate) * 0.12;

    const moving = Math.abs(rate - 1) > 0.01;
    for (const strip of strips) {
      if (!strip.visible) continue;
      for (const anim of strip.el.getAnimations({ subtree: true })) anim.playbackRate = rate;
    }
    if (moving) frame = requestAnimationFrame(tick);
  };

  const kick = () => {
    if (reduced.matches || frame) return;
    lastT = performance.now() - 16;
    frame = requestAnimationFrame(tick);
  };

  const io = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      for (const strip of strips) if (strip.el === entry.target) strip.visible = entry.isIntersecting;
    }
  });

  const init = () => {
    for (const el of document.querySelectorAll('[data-juro-velocity]')) {
      if (el.dataset.juroVelocityBound) continue;
      el.dataset.juroVelocityBound = 'true';
      strips.add({ el, visible: false });
      io.observe(el);
    }
  };

  init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('scroll', kick, { passive: true });
})();
